import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

import { SalesBreakpoint } from './Breakpoint';

import LogoSVG from '../svg/logo.svg';
import GitHubSVG from '../svg/icons/github.svg';
import LinkedInSVG from '../svg/icons/linkedin.svg';
import TwitterSVG from '../svg/icons/twitter.svg';
import SlackSVG from '../svg/icons/slack.svg';
import DevDotToSVG from '../svg/icons/dev-dot-to.svg';

const Footer = ({ stickyForm = false }) => {
  const footerClass = classnames('bg-haiti', {
    'pt-56 md:pt-64': stickyForm,
  });
  return (
    <React.Fragment>
      <footer className={footerClass}>
        <div className="max-w-6xl mx-auto px-6">
          <div className="border-b border-cornflower">
            <div className="-mx-6">
              <SalesBreakpoint />
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-6">
          <div className="py-6 md:py-12 border-b border-cornflower">
            <div className="md:flex -mx-6">
              <div className="md:w-1/4 px-6">
                <ul className="mt-6 leading-loose">
                  <li className="text-cornflower text-xs uppercase tracking-wide font-bold mb-3">
                    Company
                  </li>
                  <li>
                    <Link
                      to="/about-us"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Contact Sales
                    </Link>
                  </li>
                  <li>
                    <a
                      href="https://jobs.graphcms.com"
                      rel="nofollow noopener noreferrer"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Careers
                    </a>
                  </li>
                  <li>
                    <Link
                      to="/support"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Support
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/faq"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      FAQ
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/terms"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Terms
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/privacy"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Privacy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/imprint"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Imprint
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="md:w-1/4 px-6">
                <ul className="mt-6 leading-loose">
                  <li className="text-cornflower text-xs uppercase tracking-wide font-bold mb-3">
                    Key Concepts &amp; Features
                  </li>
                  <li>
                    <Link
                      to="/graphql-headless-cms"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      GraphQL CMS
                    </Link>
                  </li>
                   <li>
                    <Link
                      to="/graphql"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Why A GraphQL CMS?
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/react-cms"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      React CMS
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/nextjs-cms"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Next.js CMS
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/gatsby-cms"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Gatsby CMS
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/vue-cms"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Vue CMS
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/static-sites"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Static Sites
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/academy/mobile-cms"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Mobile CMS
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/webhooks"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Webhooks
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/content-localization"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Content Localization
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/mutation-api"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Mutation API
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/query-api"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Query API
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="md:w-1/4 px-6">
                <ul className="mt-6 leading-loose">
                  <li className="text-cornflower text-xs uppercase tracking-wide font-bold mb-3">
                    Product
                  </li>
                  <li>
                    <Link
                      to="/features"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Features
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/for-engineering"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      GraphCMS For Engineering
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/for-businesses"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      GraphCMS For Businesses
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/content-management-that-scales"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      For High Growth Companies
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/for-modernizing-companies"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      For Modernizing Companies
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/enterprise-headless-cms"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      For Enterprise
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/partners"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Implementation Partners
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/security-and-compliance"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Security
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/pricing"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Pricing
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/changelog"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Changelog
                    </Link>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://status.graphcms.com"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      API Status
                    </a>
                  </li>
                </ul>
              </div>

              <div className="md:w-1/4 px-6">
                <ul className="mt-6 leading-loose">
                  <li className="text-cornflower text-xs uppercase tracking-wide font-bold mb-3">
                    Resources
                  </li>
                  <li>
                    <Link
                      to="/academy/headless-cms"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      What Is A Headless CMS?
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/academy/what-is-graphql"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      What Is GraphQL?
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/case-studies"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Success Stories
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/academy"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Academy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/docs"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Documentation
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/resources"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Resource Hub
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/events"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Events
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/blog"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Blog
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/use-cases"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Solutions
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/customers"
                      className="text-whisper hover:text-cornflower text-sm"
                    >
                      Customers
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="py-6 md:py-12">
            <div className="md:flex md:items-center">
              <div className="flex md:w-2/5 items-center mb-6 md:mb-0">
                <a
                  href="https://github.com/graphcms"
                  rel="nofollow noopener noreferrer"
                  className="text-whisper hover:text-cornflower"
                >
                  <span className="sr-only">GitHub</span>
                  <GitHubSVG className="w-5 w-5" />
                </a>

                <a
                  href="https://www.linkedin.com/company/graphcms"
                  rel="nofollow noopener noreferrer"
                  className="ml-6 text-whisper hover:text-cornflower"
                >
                  <span className="sr-only">LinkedIn</span>
                  <LinkedInSVG className="w-5 w-5" />
                </a>

                <a
                  href="https://twitter.com/graphcms"
                  rel="nofollow noopener noreferrer"
                  className="ml-6 text-whisper hover:text-cornflower"
                >
                  <span className="sr-only">Twitter</span>
                  <TwitterSVG className="w-5 w-5" />
                </a>

                <a
                  href="https://slack.graphcms.com"
                  rel="nofollow noopener noreferrer"
                  className="ml-6 text-whisper hover:text-cornflower"
                >
                  <span className="sr-only">Slack</span>
                  <SlackSVG className="w-5 w-5" />
                </a>

                <a
                  href="https://dev.to/graphcms"
                  rel="nofollow noopener noreferrer"
                  className="ml-6 text-whisper hover:text-cornflower"
                >
                  <span className="sr-only">Dev.to</span>
                  <DevDotToSVG className="w-5 w-5" />
                </a>
              </div>

              <div className="md:w-1/5 hidden md:flex md:items-center md:justify-center">
                <LogoSVG className="text-white h-8" />
              </div>

              <div className="md:w-2/5 text-whisper text-sm md:text-right">
                &copy; 2020 &mdash; All Rights Reserved
              </div>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
